/* @ngInject */
const ownerRequest = (
  $q,
  ownerResource,
  utils,
  valueHandler,
  labels,
  errorHandler
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.getBySearch'
      ownerResource.post({ action: 'search', }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            owners: res.data,
            message: labels.owner.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.owner.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.countWagons = async (_ownerId) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.countWagon'
      ownerResource.post({ action: `count-wagons` }, { id: _ownerId }, (res) => {
        if (res && res.success) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName)
          reject(labels.owner.log.count.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.countParkedWagons = async (_ownerId) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.countParkedWagons'
      ownerResource.post({ action: `count-parked-wagons`, }, { id: _ownerId }, (res) => {
        if (res && res.success) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName)
          reject(labels.owner.log.count.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getById = async (_id) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_id)) {
        reject("L'id est invalide")
      }

      try {
        const response = await self.getBySearch({ id: _id, })
        const owners = response.owners
        if (owners.length === 1) {
          resolve(owners[0])
        } else {
          reject(labels.owner.log.search.noResultWithId)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getBySociety = async (_society) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isString(_society)) {
        reject(labels.owner.error.society)
      }

      try {
        const response = await self.getBySearch({ society: _society, })
        const owners = response.owners
        if (owners.length === 1) {
          resolve(owners[0])
        } else {
          reject(labels.owner.log.search.noResultWithSociety)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (_owner) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.save'

      ownerResource.save({}, _owner, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.owner.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.owner.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _owner)
            reject(labels.owner.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_owner) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.update'
      ownerResource.update({ action: _owner.id }, _owner, (res) => {
        if (res && res.success) {
          const response = {
            owner: res.data,
            message: labels.owner.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _owner)
          reject(labels.owner.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.delete'
      ownerResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.owner.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 23000) {
            reject(labels.owner.log.delete.wagonLinked)
          } else {
            errorHandler.message(res, functionName, _id)
            reject(labels.owner.log.delete.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default ownerRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/request.service.js